import React, { useEffect } from 'react';
import { useSnackbar } from 'notistack';
import { useSelector, useDispatch } from 'react-redux';
import { clearErrors } from '../../../store/actions/navigationActions';
import isEmpty from '../../../utils/isEmpty';

const ErrorWarning = () => {
  const { enqueueSnackbar } = useSnackbar();
  const dispatch = useDispatch();
  const { response, error } = useSelector(state => state.errors);

  useEffect(() => {
    if (!response && !isEmpty(error) && error !== 'Server Error') {
      enqueueSnackbar(error, { variant: 'error', autoHideDuration: 4500 });
      dispatch(clearErrors());
    }
  }, [response, dispatch, enqueueSnackbar, error]);

  return null;
};

export default React.memo(ErrorWarning);
